import { Injectable } from '@angular/core';
import * as crypto from 'crypto-js';

export interface PkceAuthVerifierState {
	code_verifier: string;
	state: string;
}

export interface OAuthAuthorizationConfig {
	clientId: string;
	scope: string;
	redirectUri: string;
	urlBeforeQuery: string;
}

@Injectable({
	providedIn: 'root',
})
export class PkceService {
	public BuildOAuthUrl(config: OAuthAuthorizationConfig) {
		const queryString = this.BuildOAuthQueryString(config);

		return `${config.urlBeforeQuery}?${queryString}`;
	}

	public BuildOAuthQueryString(config: OAuthAuthorizationConfig) {
		const { authChallenge, codeChallenge } = this.generateAuthModel();
		const queryParams = {
			client_id: config.clientId,
			response_type: 'code',
			scope: config.scope,
			redirect_uri: encodeURIComponent(config.redirectUri),
			state: authChallenge.state,
			code_challenge: codeChallenge,
			code_challenge_method: 'S256',
		};

		console.log('OAuth Query Params:', queryParams);

		const queryString = Object.keys(queryParams)
			.map((key) => `${key}=${queryParams[key]}`)
			.join('&');

		console.log('OAuth Query String:', queryString);
		return queryString;
	}

	public generateAuthModel(): {
		authChallenge: PkceAuthVerifierState;
		codeChallenge: string;
	} {
		const state = this.generateRandomString();
		const codeVerifier = this.generateRandomString();
		const codeChallenge = this.generateCodeChallenge(codeVerifier);

		const authChallenge: PkceAuthVerifierState = {
			code_verifier: codeVerifier,
			state: state,
		};

		localStorage.setItem(
			'outlook-verifier-state',
			JSON.stringify(authChallenge),
		);

		return { authChallenge, codeChallenge };
	}

	public save(pkceAuthVerifierState: PkceAuthVerifierState, key: string) {
		localStorage.setItem(key, JSON.stringify(pkceAuthVerifierState));
	}

	private generateRandomString(length = 128): string {
		const byteLength = Math.ceil(length / 2);

		const array = new Uint8Array(byteLength);
		window.crypto.getRandomValues(array);

		// Convert each byte to a hexadecimal string and join them
		const hexString = Array.from(array, (byte) =>
			byte.toString(16).padStart(2, '0'),
		).join('');

		// Return the substring of the desired length
		return hexString.slice(0, length);
	}

	private generateCodeChallenge(codeVerifier: string): string {
		return crypto.SHA256(codeVerifier).toString(crypto.enc.Base64url);
	}
}
